import { render, staticRenderFns } from "./MainContentSessions.vue?vue&type=template&id=223957cf&scoped=true&lang=pug"
import script from "./MainContentSessions.vue?vue&type=script&lang=js"
export * from "./MainContentSessions.vue?vue&type=script&lang=js"
import style0 from "./MainContentSessions.vue?vue&type=style&index=0&id=223957cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223957cf",
  null
  
)

export default component.exports